// extracted by mini-css-extract-plugin
export var root = "starting-today-module--root--1Yrx4";
export var timeSlot = "starting-today-module--timeSlot--3O2Ob";
export var time = "starting-today-module--time--gWspV";